import { createAction } from '@reduxjs/toolkit';
import { AppDispatch } from 'src/redux/store';

export const setCalendarFilterDataAction = createAction<FilterDataRequest>(
    'fetchChallengesForCalendarRequest',
);

export const setCalendarFilterData = (data: FilterDataRequest) => (dispatch: AppDispatch): void => {
    dispatch(setCalendarFilterDataAction(data));
};

export interface FilterData {
    startDate: Date;
    endDate: Date;
    challengeGroupIDs: number[];
}

export interface FilterDataRequest {
    startDate?: Date;
    endDate?: Date;
    challengeGroupIDs?: number[];
}
